export default function Footer() {
  return (
    <footer className="bg-[#2C3E50] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-5">
            <img 
              src="https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/42bcf34a0b415e0867672df7cc9a89c1.jpeg" 
              alt="L&A Contract Flooring Corp." 
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-300 leading-relaxed mb-6">
              Transforming spaces through surfaces that combine extreme durability with superior aesthetics, grounded in technical precision and operational excellence.
            </p>
            <div className="flex items-center space-x-2">
              <input
                type="email"
                placeholder="Enter your email for updates"
                className="flex-1 px-4 py-2 bg-transparent border-b border-gray-500 focus:border-[#FF6B35] outline-none transition-colors text-sm text-white placeholder-gray-400"
              />
              <button className="px-6 py-2 border-2 border-[#FF6B35] text-[#FF6B35] font-semibold rounded-full hover:bg-[#FF6B35] hover:text-white transition-all whitespace-nowrap cursor-pointer text-sm">
                Subscribe
              </button>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Corporate Carpet</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Luxury Vinyl Plank</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Hardwood Flooring</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Subfloor Preparation</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Technical Consulting</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-lg font-bold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><a href="#process" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Our Process</a></li>
              <li><a href="#warranty" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Warranty</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Careers</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-[#FF6B35] transition-colors cursor-pointer">Terms & Conditions</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-[#FF6B35] mt-1 flex-shrink-0"></i>
                <span className="text-sm">160 W. Camino Real Unit #843<br />Boca Raton, FL 33432</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-[#FF6B35] flex-shrink-0"></i>
                <a href="tel:321-201-5387" className="text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">321-201-5387</a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line text-[#FF6B35] flex-shrink-0"></i>
                <a href="mailto:Estimating@lacontractflooring.com" className="text-sm hover:text-[#FF6B35] transition-colors cursor-pointer break-all">Estimating@lacontractflooring.com</a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-time-line text-[#FF6B35] mt-1 flex-shrink-0"></i>
                <span className="text-sm">Mon-Fri: 8:00 AM - 6:00 PM<br />Sat: 9:00 AM - 2:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#FF6B35] pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 L&A Contract Flooring Corp. | All Rights Reserved
            </p>
            <div className="flex items-center space-x-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#FF6B35] transition-colors text-sm cursor-pointer">
                Powered by Readdy
              </a>
              <div className="flex items-center space-x-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-[#FF6B35] transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-[#FF6B35] transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center bg-gray-700 rounded-full hover:bg-[#FF6B35] transition-colors cursor-pointer">
                  <i className="ri-instagram-fill"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
